const toNumericLevel = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const getCompetencyLevelsForStandard = (auditor, standardId) => (
  (Array.isArray(auditor?.competencies) ? auditor.competencies : [])
    .filter((competency) => Number(competency?.standardId) === Number(standardId))
    .map((competency) => toNumericLevel(competency?.qualificationLevel))
    .filter((level) => level != null)
);

// Qualification levels are ordered by seniority: 1 is more senior than 5.
export const getMostSeniorQualificationLevel = (auditor, standardId) => {
  const levels = getCompetencyLevelsForStandard(auditor, standardId);
  return levels.length > 0 ? Math.min(...levels) : null;
};

export const isQualifiedForScope = (auditor, standardIds = []) => (
  (Array.isArray(standardIds) ? standardIds : []).every(
    (standardId) => getMostSeniorQualificationLevel(auditor, standardId) != null,
  )
);

export const getEligibleAssignmentRoles = (auditor, standardIds = [], qualificationOptions = []) => {
  const scopeLevels = (Array.isArray(standardIds) ? standardIds : [])
    .map((standardId) => getMostSeniorQualificationLevel(auditor, standardId))
    .filter((level) => level != null);

  const allRoles = Array.isArray(qualificationOptions) ? qualificationOptions : [];
  const isTraineeRole = (role) => /trainee|observer/i.test(String(role?.qualification || ''));
  const qualifiedForEveryStandard = scopeLevels.length === (Array.isArray(standardIds) ? standardIds.length : 0);

  // Observer and trainee are supervised roles. They deliberately do not consume a
  // standard competency; CRM only reads competency, while OneDatahub owns it.
  if (!qualifiedForEveryStandard) {
    return allRoles.filter(isTraineeRole);
  }

  // A grouped scope can only use the least-senior capability shared across every standard.
  const requiredLevel = scopeLevels.length > 0 ? Math.max(...scopeLevels) : null;
  if (requiredLevel == null) return allRoles.filter(isTraineeRole);

  return allRoles
    .filter((role) => {
      if (isTraineeRole(role)) return false;
      const roleLevel = toNumericLevel(role?.qualificationLevel);
      return roleLevel != null && roleLevel >= requiredLevel;
    })
    .sort((left, right) => Number(left.qualificationLevel) - Number(right.qualificationLevel));
};
